import { render, staticRenderFns } from "./refnat.vue?vue&type=template&id=c4960ff2&"
import script from "./refnat.vue?vue&type=script&lang=js&"
export * from "./refnat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports